import React, { ReactNode, useRef } from 'react'

import './style.scss'
import { useHover } from 'shared/lib/hooks/useHover'
import { onStopPropagationHandler } from 'shared/lib/hooks/onStopPropagationHandler'
import { useGetPosition } from 'utils/useGetPosition'

interface AppTooltipProps {
  className?: string
  contentClassName?: string
  children: ReactNode | string
  tooltipContent: ReactNode | string
}

export const AppTooltip = ({
  className,
  contentClassName,
  children,
  tooltipContent,
}: AppTooltipProps) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const refContent = useRef<HTMLDivElement | null>(null)
  const [isHover, hoverFnBind] = useHover()
  const position = useGetPosition(ref, isHover)
  const contentPosision = refContent?.current?.getBoundingClientRect()
  const getTop = () => {
    if (!contentPosision) return position.top
    if (position.top < contentPosision?.height + 80) {
      return position.top + contentPosision?.height + 40
    } else {
      return position.top - 12
    }
  }
  const edgeGap = 12
  const getLeft = () => {
    const centerLeft = position.left + position.width / 2
    if (!contentPosision) return centerLeft
    const halfWidth = contentPosision.width / 2
    const minLeft = halfWidth + edgeGap
    const maxLeft = window.innerWidth - halfWidth - edgeGap
    return Math.min(Math.max(centerLeft, minLeft), maxLeft)
  }
  return (
    <div className={`tooltipWrap ${className}`} ref={ref} {...hoverFnBind}>
      {children}
      {isHover && (
        <div
          className={`tooltipContent ${contentClassName || ''}`}
          ref={refContent}
          style={{
            top: getTop(),
            left: getLeft(),
          }}
          onClick={onStopPropagationHandler}
        >
          {tooltipContent}
          <div
            className="corner"
            style={{
              display:
                position.top <
                (contentPosision ? contentPosision?.height + 80 : 0)
                  ? 'none'
                  : 'block',
              left: `calc(50% - 7px + (${
                position.left + position.width / 2
              }px - ${getLeft()}px))`,
            }}
          />
        </div>
      )}
    </div>
  )
}
